import axios from 'axios'
import { API_BASE_URL } from './constant'

const apiInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
})
export default apiInstance



// import axios from 'axios';
// import Cookies from 'js-cookie';
// import { API_BASE_URL } from './constant';

// const axiosInstance = axios.create({
//   baseURL: API_BASE_URL, // or hardcode if needed
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//     Accept: 'application/json',
//   },
// });

// // Automatically attach access token
// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = Cookies.get('access_token');
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// // Optional: handle 401s globally
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 401) {
//       console.warn('Unauthorized: redirecting or logging out...');
//       // Optionally redirect to login or clear auth
//     }
//     return Promise.reject(error);
//   }
// );

// export default axiosInstance;

